// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__30CL_","footer":"ModalUpdate_footer__3_2bQ"};